import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

export const ServiceCard = ({ service, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="group service-card bg-halo-surface rounded-xl md:rounded-2xl overflow-hidden border border-halo-taupe/10"
      data-testid={`service-card-${service.slug}`}
    >
      {/* Image */}
      <div className="relative h-44 md:h-56 overflow-hidden">
        <img
          src={service.image_url}
          alt={service.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-halo-charcoal/60 to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          <span className="inline-block px-3 py-1 bg-halo-cream/90 text-halo-charcoal text-xs font-medium rounded-full">
            {service.category}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 md:p-6 space-y-3 md:space-y-4">
        <h3 className="font-heading text-lg md:text-xl text-halo-charcoal group-hover:text-halo-brown transition-colors line-clamp-1">
          {service.name}
        </h3>
        
        <p className="text-halo-text text-xs md:text-sm leading-relaxed line-clamp-2 md:line-clamp-3">
          {service.description}
        </p>

        {/* Benefits pills - hide on mobile */}
        {service.benefits && service.benefits.length > 0 && (
          <div className="hidden md:flex flex-wrap gap-2">
            {service.benefits.slice(0, 3).map((benefit, i) => (
              <span 
                key={i}
                className="text-xs px-2 py-1 bg-halo-sage/20 text-halo-charcoal rounded-full"
              >
                {benefit}
              </span>
            ))}
          </div>
        )}

        {/* Footer */}
        <div className="flex items-center justify-between pt-3 md:pt-4 border-t border-halo-taupe/10">
          <div className="flex items-center gap-3 md:gap-4">
            <span className="flex items-center gap-1 md:gap-1.5 text-xs md:text-sm text-halo-text">
              <Clock size={14} className="text-halo-brown" />
              {service.duration} min
            </span>
            <span className="text-base md:text-lg font-heading text-halo-brown">
              {service.price}€
            </span>
          </div>
          
          <Link
            to="/bonos"
            className="flex items-center gap-1 md:gap-2 text-xs md:text-sm font-medium text-halo-brown hover:text-halo-charcoal transition-colors"
            data-testid={`service-reserve-${service.slug}`}
          >
            Ver bonos
            <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default ServiceCard;
